import React, { FC } from 'react';
import { useIntercom } from 'react-use-intercom';

import Lang from 'util/IntlMessages';
import InvisibleButton from 'components/InvisibleButton';

const SupportButton: FC = () => {
  const { show } = useIntercom();
  return (
    <InvisibleButton onClick={show}>
      <Lang id="topbar.user.dropdown.support" />
    </InvisibleButton>
  );
};

export default SupportButton;
